



































































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { debounce, Dictionary, remove, shuffle } from 'lodash';
import { stripTags } from '@/app/shared/filters/filters.ts';
import { DropResult } from 'smooth-dnd';
import { injectable } from 'inversify';
import { SerializedGrouping } from '@xlearn/common';
import * as Api from "@/app/question/components/api";
import { GroupingAnswer, GroupingState } from "./grouping-interfaces";
import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';
const vuednd = require('vue-smooth-dnd');

interface Score {
  correct: number;
  incorrect: number;
}

interface GroupingCategory {
  id: string;
  title: string;
  selected: boolean;
  cards: GroupingCard[];
}

interface GroupingCard {
  id: string;
  title: string;
}

interface LodashDebounce extends Function {
  cancel: Function;
  flush: Function;
}

interface DraggedItem {
  card: GroupingCard;
  source: string | null;
}

export type GroupingCorrectAnswer = SerializedGrouping

@Component({
  components: {
    Container: vuednd.Container,
    Draggable: vuednd.Draggable
  }
})
export default class GroupingQuestionComponent extends Vue
implements Api.QuestionComponent<SerializedGrouping, GroupingAnswer, GroupingState, GroupingCorrectAnswer> {
  @Prop({
    required: true,
  })
  public question: Api.Question<SerializedGrouping>;

  @Prop({
    required: true,
  })
  public evaluated: boolean;

  @Prop({
    required: true,
  })
  public answer: Api.Answer<GroupingAnswer> | null;

  @Prop({
    required: true,
  })
  public showSolution: boolean;

  @Prop({
    required: true,
  })
  public state: Api.State<GroupingState> | null;

  private changedAnswer: Api.AnswerChangedPayload<GroupingAnswer>;

  private cards: GroupingCard[] = [];

  private categories: GroupingCategory[] = [];

  private dragging: boolean = false;

  private draggedItem: DraggedItem | null = null;

  private selectedIndex: number = 0;
  private cursorLocation: number = 0;

  private stripTags: Function = stripTags;

  private answerChangedDebouncer: LodashDebounce = debounce(this.emitAnswerChanged, 500);

  public solutionProps() {
    const defaultAnswer: GroupingAnswer = { groupMembers: {} }
    return {
      userAnswer: this.answer?.answer || defaultAnswer,
      correctAnswer: this.question.content,
    };
  };

  @Watch('answer')
  private answerChanged(newValue: Api.Answer<GroupingAnswer> | null): void {
    if (!this.answer) {
      this.setInitialState();
    }
  }

  private hideIfDragging(category: GroupingCategory) {
    if (document.querySelector('.smooth-dnd-ghost')) {
      this.hideAllCategory();
    }
  }

  private hideAllCategory(except?: GroupingCategory) {
    this.categories.forEach((category: GroupingCategory) => {
      if (!except || except && category !== except) {
        category.selected = false
      }
    });
  }

  private selectCategory(category: GroupingCategory, state?: boolean): void {
    if (!this.dragging) {
      this.hideAllCategory(category);

      category.selected = state === undefined
        ? !category.selected
        : state;
    }
  }

  private calculateAnswerChanged(finished: boolean): void {
    const groupMembers: Dictionary<string[]> = {};
    let score: number = 0;
    this.categories.forEach((category) => {
      category.cards.forEach((card: GroupingCard) => {
        if (!groupMembers[category.id]) {
          groupMembers[category.id] = [];
        }
        groupMembers[category.id] = [...groupMembers[category.id], card.id];

        const Score: Score = this.getMemberScoreById(card.id);
        const inCorrectGroup: boolean = this.isMemberInCorrectGroup(card.id, category.id);

        if (!inCorrectGroup) {
          score += Score.incorrect;
        } else {
          score += Score.correct;
        }
      });
    });

    this.changedAnswer = {
      answer: {
        groupMembers,
      },
      score
    };

    this.answerChangedDebouncer();
  }

  @Emit('answer-changed')
  public emitAnswerChanged(): Api.AnswerChangedPayload<GroupingAnswer> {
    return this.changedAnswer;
  }

  @Emit('state-changed')
  public emitStateChanged(state: Api.StateChangedPayload<GroupingState>): Api.StateChangedPayload<GroupingState> {
    return state;
  }

  private isMemberInCorrectGroup(memberId: string, groupId: string): boolean {
    for (const group of this.question.content.groups) {
      if (group.id !== groupId) {
        continue;
      }

      const found = group.members.find((member) => member.id === memberId);
      if (found) {
        return true;
      }
    }

    return false;
  }

  private mounted(): void {
    this.setInitialState();

    if (!this.state) {
      this.emitStateChanged({
        state: {
          cardsOrder: this.cards.map(card => card.id)
        }
      });
    }
  }

  private allCards(): Array<{ id: string; title: string }> {
    let cards: Array<{ id: string; title: string }> = [];
    this.question.content.groups.forEach((group) => {
      group.members.forEach((member) => {
        cards = [...cards, {
          id: member.id,
          title: member.text
        }];
      });
    });

    if (this.state !== null) {
      const cardsOrder = this.state.state.cardsOrder;
      cards.sort((a: GroupingCard, b: GroupingCard) =>
        cardsOrder.indexOf(a.id) < cardsOrder.indexOf(b.id) ? -1 : 1
      );
    } else {
      cards = shuffle(cards);
    }

    return cards;
  }

  private initialCategories() {
    let categories: GroupingCategory[] = [];
    this.question.content.groups.forEach((group) => {
      categories = [...categories, {
        id: group.id,
        title: group.label,
        selected: false,
        cards: []
      }];
    });

    return categories;
  }

  private getMemberScoreById(id: string): Score {
    for (const group of this.question.content.groups) {
      const found = group.members.find((member) => member.id === id);
      if (found) {
        return found.score;
      }
    }

    throw new Error(`Member not found in question with id: ${id}`);
  }

  private setInitialState(): void {
    let grouppedCardIds: string[] = [];

    this.cards = this.allCards();
    this.categories = this.initialCategories();

    this.categories.forEach((category) => {
      const memberIds: string[] = this.answer?.answer.groupMembers[category.id] || [];

      grouppedCardIds = grouppedCardIds.concat(memberIds);
      memberIds.forEach((memberId: string) => {
        const found = this.cards.find((card) => card.id === memberId);

        if (found) {
          category.cards = [...category.cards, found];
        }
      });
    });

    this.cards = this.cards.filter(card => grouppedCardIds.indexOf(card.id) < 0);
  }

  private columnDrop($event: DropResult, categoryId: string | null) {
    if (!$event) return;

    const { removedIndex, addedIndex, payload } = $event;

    this.dragging = false;

    let target;
    let index;

    if (!categoryId && removedIndex !== null && addedIndex !== null) {
      return;
    }

    if (categoryId) {
      this.categories.forEach((cat: GroupingCategory, i: number) => {
        if (cat.id == categoryId) {
          index = i;
        }
      })
    }

    if (index === undefined) {
      target = this.cards;
    } else {
      target = this.categories[index].cards;
    }

    if (removedIndex !== null) {
      target.splice(removedIndex, 1);
    }

    if (addedIndex !== null && payload) {
      target.splice(addedIndex, 0, payload);
    }

    this.calculateAnswerChanged(this.cards.length === 0);
  }

  private getCardPayloadCardsWrapper(index: number) {
    return this.cards[index];
  }

  private getCardPayloadCategories(categoryIndex: number) {
    return (cardIndex: number) => {
      return this.categories[categoryIndex].cards[cardIndex];
    }
  }

  private cardsDragNDrop(): void {
    if (!this.draggedItem) {
      this.draggedItem = {
        card: this.cards[0],
        source: null
      };

      this.cursorLocation = -1;
    } else {
      this.draggedItem = null;
    }
  }

  private releaseDraggedItem() {
    this.draggedItem = null;
  }

  private moveLeftIfDragged(index?: number) {
    if (!this.draggedItem) {
      return false;
    }

    if (index !== undefined) {
      this.cursorLocation = index;
    }

    this.cursorLocation = Math.max(this.cursorLocation - 1, 0);
    const currentCategory = this.categories[this.cursorLocation];
    this.onOpenCategory(currentCategory, this.cursorLocation, true);
    this.categoryDragNDrop(currentCategory.id, this.cursorLocation);
    this.categoryDragNDrop(currentCategory.id, this.cursorLocation, 0);
  }

  private moveRightIfDragged(index?: number) {
    if (!this.draggedItem) {
      return false;
    }

    if (index !== undefined) {
      this.cursorLocation = index;
    }

    this.cursorLocation = Math.min(this.cursorLocation + 1, this.categories.length - 1);
    const currentCategory = this.categories[this.cursorLocation];
    this.onOpenCategory(currentCategory, this.cursorLocation, true);
    this.categoryDragNDrop(currentCategory.id, this.cursorLocation);
    this.categoryDragNDrop(currentCategory.id, this.cursorLocation, 0);
  }

  private focusIfDragged(card: GroupingCard) {
    if (this.draggedItem && card && this.draggedItem.card.id === card.id) {
      this.$nextTick(() => {
        const refs = this.$refs[card.id] as HTMLElement[];
        refs[0].focus();
      });
    }

    return 'kategória elem: ' + stripTags(card.title);
  }

  private preventIfDragging(e: Event) {
    if (this.draggedItem) {
      e.preventDefault();
    }
  }

  private toggleOrDrop(categoryId: string, categoryIndex: number) {
    if (!this.categories[categoryIndex] || this.categories[categoryIndex].cards.length && !this.draggedItem) {
      this.onOpenCategory(this.categories[categoryIndex], categoryIndex);
    } else {
      this.categoryDragNDrop(categoryId, categoryIndex);
    }
  }

  private categoryDragNDrop(categoryId: string, categoryIndex: number, cardIndex?: number): void {
    if (!this.draggedItem) {
      if (cardIndex !== undefined) {
        this.selectedIndex = cardIndex;
      }

      if (this.categories[categoryIndex].cards.length) {
        this.draggedItem = {
          card: this.categories[categoryIndex].cards[this.selectedIndex],
          source: categoryId
        };
      }
    } else {
      this.columnDrop({
        removedIndex: this.selectedIndex,
        addedIndex: null,
      }, this.draggedItem.source);

      this.columnDrop({
        removedIndex: null,
        addedIndex: 0,
        payload: this.draggedItem.card
      }, categoryId);

      this.draggedItem = null;
    }
  }

  private dropDraggedItem() {
    this.draggedItem = null;
    this.dragging = true;
  }

  private onOpenCategory(category: GroupingCategory, categoryIndex: number, state?: boolean) {
    this.selectCategory(category, state);
  }

  private getGhostParent() {
    return document.querySelector('.grouping-component');
  }

  private removeBodyTouchDisableClass() {
    document.body.classList.remove('smooth-dnd-disable-touch-action');
  }

  private beforeDestroy() {
    this.answerChangedDebouncer.cancel();
  }

  private t(key: string, params: any = {}): TranslateResult {
    return i18n.t(key, params);
  }
}
